/* @flow */
import * as React from 'react';

const TruckWithUfo = props => (
  <svg
    width={166}
    height={98}
    viewBox="0 0 166 98"
    stroke="none"
    strokeWidth={1}
    fillRule="evenodd"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path
      fill="#677BC5"
      d="M59.35,2.224 C63.554,2.297 68.277,4.004 70.782,6.689 C79.071,15.575 72.611,36.109 56.351,52.552 L50.536,52.552 C80.785,22.021 75.823,4.385 59.35,2.224"
    />
    <path
      fill="#FFFFFF"
      d="M54.7,48.432 C70.373,33.21 76.6,14.2 68.61,5.973 C60.619,-2.253 41.436,3.417 25.764,18.64 C14.193,29.878 7.779,43.176 8.425,52.679 L49.936,52.679 C51.549,51.359 53.142,49.945 54.7,48.432 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M54.7,48.432 C70.373,33.21 76.6,14.2 68.61,5.973 C60.619,-2.253 41.436,3.417 25.764,18.64 C14.193,29.878 7.779,43.176 8.425,52.679 L49.936,52.679 C51.549,51.359 53.142,49.945 54.7,48.432 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M56.352,54.72 C73.311,37.569 80.05,16.151 71.403,6.881 C68.79,4.08 63.864,2.301 59.479,2.224"
    />
    <path
      fill="#677BC5"
      d="M49.9,12.661 C54.239,17.128 50.857,27.449 42.348,35.714 C33.838,43.979 23.423,47.058 19.084,42.591 C14.746,38.125 15.334,24.928 23.844,16.663 C32.353,8.398 45.561,8.194 49.9,12.661"
    />
    <path
      stroke="#3A427C"
      strokeWidth={3}
      d="M49.9,12.661 C54.239,17.128 50.857,27.449 42.348,35.714 C33.838,43.979 23.423,47.058 19.084,42.591 C14.746,38.125 15.334,24.928 23.844,16.663 C32.353,8.398 45.561,8.194 49.9,12.661 Z"
    />
    <path
      fill="#FFFFFF"
      d="M20.167,38.368 C18.234,36.378 17.134,32.915 17.054,28.854 C15.731,34.586 16.594,40.027 19.084,42.591 C23.423,47.058 33.838,43.979 42.348,35.714 C43.637,34.461 44.807,33.161 45.852,31.841 C36.186,40.375 24.989,43.332 20.167,38.368"
    />
    <path stroke="#1C1F34" strokeWidth={2} d="M29.783,12.453 L26.756,23.494" />
    <path stroke="#1C1F34" strokeWidth={2} d="M36.406,10.747 L34.706,17.711" />
    <path
      fill="#1C1F34"
      d="M65.214,11.677 C65.817,13.358 64.486,15.374 62.241,16.18 C59.996,16.985 57.687,16.275 57.084,14.594 C56.481,12.913 57.812,10.897 60.057,10.091 C62.302,9.286 64.611,9.996 65.214,11.677"
    />
    <path
      fill="#1C1F34"
      d="M51.829,38.368 C50.451,36.949 47.743,37.344 45.781,39.249 C43.819,41.155 43.346,43.85 44.724,45.269 C46.102,46.688 48.81,46.293 50.772,44.387 C52.734,42.482 53.207,39.787 51.829,38.368"
    />
    <path
      fill="#1C1F34"
      d="M62.878,24.847 C61.913,23.329 59.429,23.18 57.33,24.515 C55.231,25.85 54.311,28.162 55.277,29.68 C56.242,31.198 58.726,31.347 60.825,30.012 C62.924,28.678 63.843,26.365 62.878,24.847"
    />
    <path
      fill="#1C1F34"
      d="M20.807,49.829 C19.144,49.177 17.09,50.448 16.22,52.669 C16.218,52.673 16.218,52.676 16.217,52.679 L22.61,52.679 C22.512,51.355 21.872,50.246 20.807,49.829"
    />
    <path
      fill="#1C1F34"
      d="M35.94,48.462 C34.451,47.453 32.113,48.304 30.717,50.364 C30.212,51.11 29.905,51.912 29.783,52.68 L36.781,52.68 C37.396,50.978 37.116,49.259 35.94,48.462"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M49.9,12.661 C54.239,17.128 50.857,27.449 42.348,35.714 C33.838,43.979 23.423,47.058 19.084,42.591 C14.746,38.125 15.334,24.928 23.844,16.663 C32.353,8.398 45.561,8.194 49.9,12.661 Z"
    />
    <path stroke="#1C1F34" strokeWidth={3} d="M14.785,95.757 L158.853,95.757" />
    <path
      fill="#677BC5"
      d="M142.994,88.112 C139.77,88.112 137.156,85.499 137.156,82.275 C137.156,79.05 139.77,76.438 142.994,76.438 C146.218,76.438 148.832,79.05 148.832,82.275 C148.832,85.499 146.218,88.112 142.994,88.112 M142.994,69.251 C135.801,69.251 129.971,75.082 129.971,82.275 C129.971,89.468 135.801,95.299 142.994,95.299 C150.187,95.299 156.017,89.468 156.017,82.275 C156.017,75.082 150.187,69.251 142.994,69.251"
    />
    <path
      fill="#677BC5"
      d="M32.319,82.275 C32.319,79.05 34.933,76.438 38.157,76.438 C41.381,76.438 43.995,79.05 43.995,82.275 C43.995,85.499 41.381,88.112 38.157,88.112 C34.933,88.112 32.319,85.499 32.319,82.275 Z M25.134,82.275 C25.134,89.468 30.964,95.299 38.157,95.299 C45.35,95.299 51.18,89.468 51.18,82.275 C51.18,75.082 45.35,69.251 38.157,69.251 C30.964,69.251 25.134,75.082 25.134,82.275 Z"
    />
    <path
      fill="#1C1F34"
      d="M43.994,82.275 C43.994,79.051 41.38,76.438 38.157,76.438 C34.933,76.438 32.319,79.051 32.319,82.275 C32.319,85.499 34.933,88.112 38.157,88.112 C41.38,88.112 43.994,85.499 43.994,82.275"
    />
    <path
      fill="#E7EBF6"
      d="M4.222,72.7 L10.786,75.468 L20.83,75.824 C20.83,75.824 23.605,63.791 38.157,63.791 C52.709,63.791 56.48,79.829 56.48,79.829 L123.716,79.829 C123.716,79.829 128.125,63.812 143.763,63.812 C143.763,63.812 151.075,63.717 156.915,70.115 L161.998,70.115 L160.585,61.877 C160.585,61.877 159.897,59.667 156.017,58.337 C152.137,57.007 128.149,54.388 128.149,54.388 C128.149,54.388 125.583,53.724 122.345,50.709 C119.106,47.694 111.192,39.485 104.511,38.378 C97.829,37.271 74.301,36.959 74.301,36.959 L70.732,42.942 L69.732,52.84 L8.984,52.84 C8.984,52.84 4.304,52.146 4.304,57.285 C4.304,62.424 4.222,72.7 4.222,72.7"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M156.017,82.275 C156.017,75.082 150.186,69.252 142.994,69.252 C135.801,69.252 129.971,75.082 129.971,82.275 C129.971,89.468 135.801,95.298 142.994,95.298 C150.186,95.298 156.017,89.468 156.017,82.275 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M161.952,70.116 L156.915,70.116 C153.527,66.24 148.546,63.792 142.994,63.792 C133.615,63.792 125.867,71.705 124.671,80.757 L56.48,80.757"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M51.18,82.275 C51.18,75.082 45.349,69.252 38.157,69.252 C30.964,69.252 25.134,75.082 25.134,82.275 C25.134,89.468 30.964,95.298 38.157,95.298 C45.349,95.298 51.18,89.468 51.18,82.275 Z"
    />
    <path
      fill="#1C1F34"
      d="M148.83,82.275 C148.83,79.051 146.216,76.438 142.993,76.438 C139.769,76.438 137.155,79.051 137.155,82.275 C137.155,85.499 139.769,88.112 142.993,88.112 C146.216,88.112 148.83,85.499 148.83,82.275"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M56.48,79.83 C55.284,70.777 47.536,63.791 38.157,63.791 C30.218,63.791 23.447,68.797 20.83,75.825 L17.483,75.825 C14.852,75.825 8.39,74.808 6.241,73.29 C5.748,72.941 5.092,72.7 4.222,72.7"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M156.403,83.682 C156.403,83.682 162.689,82.243 163.312,78.331 C163.603,76.508 163.594,74.813 163.58,73.365 C163.563,71.704 162.684,70.308 161.998,70.308 C161.998,70.308 161.671,61.739 159.455,60.168 C157.239,58.597 144.595,55.921 129.264,54.203 C129.264,54.203 128.424,53.982 125.764,51.953 C123.105,49.923 106.927,36.757 95.74,36.757 L75.3,36.757 C75.3,36.757 72.409,36.959 70.633,42.096 L69.732,52.841 L6.669,52.841 L4.5,54.535 L4.5,72.7 C4.5,72.7 2.5,72.832 2.5,74.433 C2.5,75.186 2.487,77.049 2.5,78.813 C2.516,80.947 4.721,82.668 6.855,82.668 L11.092,82.668 L22.136,85.146 L25.362,85.146"
    />
    <path stroke="#1C1F34" strokeWidth={3} d="M51.917,86.757 L129.233,86.757" />
    <path
      fill="#FFFFFF"
      d="M92.741,57.814 L118.169,57.87 C118.169,57.87 118.714,55.013 116.69,52.811 C114.666,50.609 105.946,43.695 100.029,42.658 C94.112,41.622 91.516,41.802 91.516,41.802 C91.516,41.802 90.348,41.931 90.426,43.032 C90.488,43.905 90.357,52.015 90.827,55.345 C90.942,56.161 91.202,57.814 92.741,57.814"
    />
    <path
      fill="#677BC5"
      d="M83.999,42.577 L75.755,42.577 C75.766,45.396 75.783,50.523 76.133,53.003 C76.248,53.819 76.509,55.471 78.047,55.471 L84.872,55.486 C84.574,54.509 84.52,53.446 84.745,52.39 C85.407,49.285 85.123,45.68 83.999,42.577"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M75.142,79.83 C75.142,79.83 71.845,77.79 70.595,70.54 C69.345,63.29 69.732,52.841 69.732,52.841"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M92.554,57.665 L119.597,58.751 C119.597,58.751 120.041,54.926 118.394,52.773 C116.747,50.619 105.69,43.847 100.877,42.833 C96.063,41.82 90.526,41.757 90.526,41.757 C90.526,41.757 89.576,42.132 89.639,43.209 C89.689,44.062 90.615,51.994 90.996,55.251 C91.09,56.049 91.302,57.665 92.554,57.665 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M83.341,41.757 L77.141,41.757 C76.367,41.757 75.71,42.569 75.593,43.334 C75.337,45.005 74.984,48.069 75.161,51.453 C75.161,51.453 75.394,53.385 76.623,54.511 C77.715,55.511 78.566,56.381 83.743,56.268 C84.536,56.251 85.178,55.617 85.196,54.824 C85.244,52.708 85.259,48.381 84.814,43.357 C84.747,42.593 84.108,41.757 83.341,41.757 Z"
    />
  </svg>
);

export default TruckWithUfo;



// WEBPACK FOOTER //
// ./src/assets/images/icons/truck-with-ufo.js